<template>
  <div class="new-password">
    <el-form :model="newPassword" :rules="passRules" ref="newPassword" label-width="120px" label-position="right" :hide-required-asterisk="true">
      <el-form-item class="password" label="设置新密码" prop="password">
        <el-row>
          <el-col :span="16">
            <el-input v-focus type="password" v-model="newPassword.password" placeholder="请输入新密码" autocomplete="off" maxlength="16" @input="checkPassword"></el-input>
          </el-col>
          <el-col :span="6">
            <div class="password-nemesis">
              <ul :class="[strength]">
                <li>弱</li>
                <li>中</li>
                <li>强</li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="再次输入新密码" prop="checkPass">
        <el-input type="password" v-model="newPassword.checkPass" placeholder="请再次输入新密码" autocomplete="off" maxlength="16"></el-input>
      </el-form-item>
      <div class="el-icon-warning hint">
        <p>密码长度为6~16个字符，至少包含数字/字母/字符任意2种组合</p>
      </div>
      <el-form-item class="next-button">
        <el-button type="primary" @click="next('newPassword')">下一步</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import CookieOperation from '@/plugins/cookie'
export default {
  name: 'newPassword',
  props: {
    phoneNumber: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  data () {
    let validatePass = (rule, value, callback) => {
      let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&?*]+$)[a-zA-Z\d!@#$%^&?*]+$/
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('新密码不符合密码规则'))
      } else if (reg.test(value) === false) {
        callback(new Error('新密码不符合密码规则'))
      } else {
        callback()
        this.canSubmit = false
      }
    }
    let passwordConfirm = (rule, value, callback) => {
      let reg = /^(?![a-zA-z]+$)(?!\d+$)(?![!@#$%^&?*]+$)[a-zA-Z\d!@#$%^&?*]+$/
      if (value === '') {
        callback(new Error('请确认新密码'))
      } else if (value !== this.newPassword.password) {
        callback(new Error('两次输入密码不一致!'))
      } else if (value.length < 6 || value.length > 16) {
        callback(new Error('新密码不符合密码规则'))
      } else if (reg.test(value) === false) {
        callback(new Error('新密码不符合密码规则'))
      } else {
        callback()
        this.canSubmit = false
      }
    }
    return {
      tenantId: '',
      newPassword: {
        password: '',
        checkPass: '',
        level: 0
      },
      active: 1,
      passRules: {
        password: [
          { validator: validatePass, trigger: 'change' },
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: passwordConfirm, required: true, trigger: 'change' },
          { required: true, message: '请确认新密码', trigger: 'blur' },
          { validator: passwordConfirm, trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.tenantId = CookieOperation.get('tenantId')
  },
  methods: {
    checkPassword () {
      // 只包含数字
      if (/(?=.*\d).{6,16}/.test(this.newPassword.password)) {
        this.newPassword.level = 1
      } else {
        this.newPassword.level = 0
      }
      if (/^(?=.*[a-zA-z])(?=.*\d).{6,16}$/.test(this.newPassword.password)) {
        this.newPassword.level = 2
      }
      if (/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,16}$/.test(this.newPassword.password)) {
        this.newPassword.level = 3
      }
    },
    next (formName) {
      this.$refs.newPassword.validate(v => {
        if (v) {
          this.$axios
            .post(
              '/auth-api/login/no-auth/forgetPassword',
              {
                telephone: this.phoneNumber,
                telCode: this.message,
                password: this.newPassword.password,
                tenantId: this.tenantId,
                isAdmin: false
              },
              {
                headers: {
                  tenantId: this.tenantId
                }
              }
            )
            .then(res => {
              if (res.data === true) {
                this.active++
                this.$emit('next', this.active)
              }
            })
        } else {
          return false
        }
      })
    }
  },
  computed: {
    strength () {
      return 'strength' + this.newPassword.level
    }
  }
}
</script>

<style lang="scss">
.new-password{
  width: 725px;
  .el-form {
    .el-form-item {
      .el-form-item__content {
        .el-input {
          width:350px;
          height: 32px;
          .el-input__inner{
            height: 32px;
            line-height: 32px;
            border: 1px solid #C2BFBE;
            border-radius: 4px;
          }
        }
      }
    }
  }
  .hint{
    color: var(--primary, #55acf1);
    width: 500px;
    margin-left: 120px;
    p{
      font-size: 12px;
      color: #a6a6a6;
      display: inline-block;
      margin-left: 5px;
    }
  }
  .password{
    .password-nemesis{
      width: 300px;
      height: 32px;
      padding-top: 4px;
      ul {
        overflow: hidden;
        display: flex;
        justify-content: center;
        >li {
          width:70px;
          height:22px;
          line-height: 22px;
          background: #f2f1ef;
          text-align: center;
          font-size: 10px;
          border-radius: 4px;
          margin-left: 7px;
        }
      }
      .strength1 li:first-child{
        background: #fb615e;
        color: #ffffff;
      }
      .strength2 li:nth-child(1),.strength2 li:nth-child(2){
        background: #fb615e;
        color: #ffffff;
      }
      .strength3 li{
        background: #fb615e;
        color: #ffffff;
      }
    }
  }
  .next-button {
    .el-form-item__content {
      margin-top: 64px;
      .el-button {
        width: 108px;
        height: 32px;
        background: var(--primary, #659FF0);
        border-radius: 4px;
        border-color: var(--primary, #659FF0);
        padding: 0;
        &:hover, &:active, &:focus {
          background: var(--primary, #659FF0);
          border-color: var(--primary, #659FF0);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/system/forgetPassword/newPassword.vue